<template>
  <div id="traffic" class="full-width">
    <div v-if="selectedItem">
        <div v-for="(key, index) in Object.keys(selectedItem.properties)" :key="key" class="columns">
          <div class="column">
            {{ labels[key] }}:
          </div>
          <div class="column">
           {{ selectedItem.properties[key] }}
         </div>
       </div>
    </div>
    <span v-else>Nothing to see here!</span>
  </div>
</template>

<script>

export default {
  name: 'Traffic',
  components: {
  },
  data(){
    return {
            labels: {
          description:'Locatie',
          eventCount:'Totaal aantal verkeerslustellingen',
          detectionCount:'Totaal aantal tellingen',
          buttonPushes_FTS: 'Ingedrukte fietsknoppen',
          buttonPushes_VTG: 'Ingedrukte voetgangersknoppen',
          passages_MVT: 'Aantal passages motorvoertuigen',
          passages_OV: 'Aantal passages openbaar vervoer',
          passages_FTS: 'Aantal passages fietsen',
      }
    }
  },
  props: {
    selectedType: String,
    selectedItem: Object,
  },
}
</script>
<style scoped>
.full-width{
  width: 100%;
}
.columns {
  margin-bottom: 3px;
}
</style>
